import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { SendPostRequest } from "../../http";
import "./FadeSlider.css";

const FadeSlider = () => {
    const [slides, setSlides] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [titleVisible, setTitleVisible] = useState(false);
    const [descVisible, setDescVisible] = useState(false);
    const sitedata = useSelector((store) => store.global.loginData);

    const titleTimeout = useRef(null);
    const descTimeout = useRef(null);
    const slideTimeout = useRef(null);

    useEffect(() => {
        fetchSlides();
    }, []);

    useEffect(() => {
        if (slides.length > 0) {
            startSlideShow();
        }
        return () => {
            clearTimeout(titleTimeout.current);
            clearTimeout(descTimeout.current);
            clearTimeout(slideTimeout.current);
        };
    }, [activeIndex, slides]);

    const fetchSlides = async () => {
        const siteTheme = sitedata?.options?.theme;
        const response = await SendPostRequest("branding/banners", {
            theme: siteTheme,
        });
        setSlides(response?.data || []);
    };

    const startSlideShow = () => {
        // Reset visibility for new slide
        setTitleVisible(false);
        setDescVisible(false);

        // Show title after 0.5s (sliding from left)
        titleTimeout.current = setTimeout(() => setTitleVisible(true), 1500);

        // Show description after 1.5s (sliding from right)
        descTimeout.current = setTimeout(() => setDescVisible(true), 2000);

        // Move to next slide after 6s
        slideTimeout.current = setTimeout(() => {
            nextSlide();
        }, 7000);
    };

    const nextSlide = () => {
        setActiveIndex((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    };

    const prevSlide = () => {
        setActiveIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
    };

    const goToSlide = (index) => setActiveIndex(index);

    return (
        <div className="new-fade-banner-slider">
            <div className="new-fade-banner-slider-wrapper">
                {slides.map((slide, index) => (
                    <div
                        key={index}
                        className={`new-fade-banner-slide ${index === activeIndex
                            ? "new-fade-banner-active"
                            : index < activeIndex
                                ? "new-fade-banner-left"
                                : "new-fade-banner-right"
                            }`}
                    >
                        <div className="new-fade-banner-slide-image">
                             {slide?.banner_category === "custom-text" && (

                            <div className="new-fade-banner-shadow"></div>
                              )}
                            <img src={slide?.banner_image} alt={slide?.banner_title} />
                        </div>
                        {slide?.banner_category === "custom-text" && (
                            <div className="new-fade-banner-slide-content-wrapper">
                                <div className="container">
                                    <div
                                        className={`new-fade-banner-slide-content ${slide?.banner_alignment === "right" ? "align-left" : "align-center"
                                            }`}
                                    >
                                        <h2
                                            className={`new-fade-banner-slide-title banner-title-font ${titleVisible ? "new-fade-banner-visible" : ""
                                                }`}
                                        >
                                            {slide?.banner_title}
                                        </h2>
                                        <p
                                            className={`new-fade-banner-slide-description ${descVisible ? "new-fade-banner-visible" : ""
                                                }`}
                                        >
                                            {slide?.banner_description}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}

                    </div>
                ))}
            </div>

            <button className="new-fade-banner-arrow new-fade-banner-left-arrow" onClick={prevSlide}>
                <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>
            <button className="new-fade-banner-arrow new-fade-banner-right-arrow" onClick={nextSlide}>
                <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 18L15 12L9 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>
        </div>
    );
};

export default FadeSlider;